<template>
  <div id="food-entry" class="flex">
    <div class="md:rounded-md bg-teal-500 flex-grow shadow-md  p-4 print:p-2 print:pb-1">
      <div class="flex-row print:flex-wrap content-center">
        <img class="rounded-full border-4 border-teal-900 print:w-2/3 md:float-left print:float-right mr-8"
             v-bind:src="food.imagePath"
             v-bind:alt="$t(food.name)">
        <div class="text-left print:text-center">
          <h2 class="print:mt-1 text-3xl tracking-wider text-gree00 font-bold food-title">{{ $t(food.name) }}</h2>
          <br class="print:hidden"/>
          <p v-html="$t(food.description)" class="print:hidden"></p>
        </div>
      </div>

      <p class="clearfix print:hidden"></p>

      <div class="md:flex-row md:space-x-2 mt-6 text-left text-sm print:hidden">
        <span v-if="food.goodFor==='b' || food.goodFor==='bm'" class="bg-green-400 rounded-full p-2 whitespace-no-wrap ">
          &nbsp;
          <icon name="information-circle" class="inline w-6 h-6 mr-1"/>
          {{ $t("brain") }}
        </span>
        <br class="md:hidden" />
        <br class="md:hidden" />
        <span v-if="food.goodFor==='m' || food.goodFor==='bm'" class="bg-green-400 rounded-full p-2 whitespace-no-wrap ">
          &nbsp;
          <icon name="information-circle" class=" inline w-6 h-6 mr-1"/>
          {{ $t("muscle") }}
        </span>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "food-entry",
  props: {
    food: Object
  }
}
</script>

<style scoped>
.food-title {
  font-family: 'Lobster', cursive;
}

@media print {
  .food-title {
    font-size: small;
  }
}

</style>